export { default as CarModel } from './car-model';

export { VehicleState as CarState } from './car-model';
